import styled from 'styled-components';

export const Underline = styled.span`
  text-decoration: underline;
  text-underline-offset: 3px;
  text-decoration-color: ${props => props.theme.colors.yellow};
`;
